import { gql } from '@apollo/client'

const GIFT_FOR_CHAT_USER_QUERY = gql`
  query GiftedCreativeResponseQuery(
    $avoidType: String, 
    $language: String
  ) {
    creativeResponses: random_response(
      args: { 
        avoid_type: $avoidType
        language: $language
      }
    ) {
      id
      image_object
      audio_object
      file_data
      age
      country
      created_at
      approved_at
      language
      activity {
        ...on activities_default_Entry {
          id: canonicalId,
          slug
          title
          activityType {
            ...on activityTypes_Category {
              id
              title
              slug
            }
          }
        }
      }
    }
  }
`
  
export default GIFT_FOR_CHAT_USER_QUERY
